module.exports = __webpack_public_path__ + "static/media/icon-check.ec6d5bd6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-check.svg
// module id = ./src/assets/images/icon-check.svg
// module chunks = 6